import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { MapCableDataPoint } from '@/server/MakeSenseApp-backend'
import { ref, PropType } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CableAcoustics',
  props: {
  sensorReadings: {
    type: Array as PropType<MapCableDataPoint[]>,
    required: true
  },
  isVisible: {
    type: Boolean,
    required: true
  }
},
  setup(__props) {

const strokeWidth = ref(4)
const strokeColor = ref('#06A3DA')

const acousticLenghtConstant = ref(150)

const props = __props

const getSlope = (x1: number, y1: number, x2: number, y2: number) => {
  return (y2 - y1) / (x2 - x1)
}

const getPerpendicularSlope = (a: number) => {
  return -1 / a
}

// Vector [1,a]
const getSlopeUnitVector = (a: number) => {
  const magnitude = Math.sqrt(1 + a * a)
  return [1 / magnitude, a / magnitude]
}

const getAcousticCoordinates = (i: number, direction: boolean) => {
  const das = props.sensorReadings[i].das ?? 0

  const [x1, y1] = [
    props.sensorReadings[i].coordinate?.easting ?? 0,
    props.sensorReadings[i].coordinate?.northing ?? 0
  ]
  const [x2, y2] = [
    props.sensorReadings[i + 1].coordinate?.easting ?? 0,
    props.sensorReadings[i + 1].coordinate?.northing ?? 0
  ]

  const slope = getSlope(x1, y1, x2, y2)

  const slope_perpendicular = getPerpendicularSlope(slope)

  const [unitX, unitY] = getSlopeUnitVector(slope_perpendicular)

  const scaledX = unitX * (das * acousticLenghtConstant.value + 300)
  const scaledY = unitY * (das * acousticLenghtConstant.value + 300)

  if (direction) {
    return [
      [x1, y1],
      [x1 + scaledX, y1 + scaledY]
    ]
  } else {
    return [
      [x1, y1],
      [x1 - scaledX, y1 - scaledY]
    ]
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ol_geom_line_string = _resolveComponent("ol-geom-line-string")!
  const _component_ol_style_stroke = _resolveComponent("ol-style-stroke")!
  const _component_ol_style = _resolveComponent("ol-style")!
  const _component_ol_feature = _resolveComponent("ol-feature")!
  const _component_ol_source_vector = _resolveComponent("ol-source-vector")!
  const _component_ol_vector_layer = _resolveComponent("ol-vector-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ol_vector_layer, {
      zIndex: "6",
      visible: __props.isVisible
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ol_source_vector, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sensorReadings.slice(0, -1), (dasValue, index) => {
              return (_openBlock(), _createBlock(_component_ol_feature, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_ol_geom_line_string, {
                    coordinates: getAcousticCoordinates(index, true)
                  }, null, 8, ["coordinates"]),
                  _createVNode(_component_ol_style, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ol_style_stroke, {
                        "line-cap": "butt",
                        "line-join": "miter",
                        color: strokeColor.value,
                        width: strokeWidth.value
                      }, null, 8, ["color", "width"])
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ol_vector_layer, { visible: __props.isVisible }, {
      default: _withCtx(() => [
        _createVNode(_component_ol_source_vector, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sensorReadings.slice(0, -1), (_, index) => {
              return (_openBlock(), _createBlock(_component_ol_feature, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_ol_geom_line_string, {
                    coordinates: getAcousticCoordinates(index, false)
                  }, null, 8, ["coordinates"]),
                  _createVNode(_component_ol_style, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ol_style_stroke, {
                        "line-cap": "butt",
                        "line-join": "miter",
                        color: strokeColor.value,
                        width: strokeWidth.value
                      }, null, 8, ["color", "width"])
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})